
import { Component, Vue } from 'vue-property-decorator';

@Component({})

export default class NoTenantVue extends Vue {
  private profile: any = this.$auth0.user

  private handleLoginEvent(data: any) {
    this.profile = data.profile
  }
}
